// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhk_sq","PhotoTitleEditForm__cancelBtn":"iy_b bhk_su bhk_st"};